import { defineMessages } from "react-intl";

export const paymentRecoveryMessages = defineMessages({
  pageSubtitle: {
    id: "DuhHBR",
    defaultMessage:
      "Checkouts that took money but never became orders. This list is normally empty.",
    description: "payment recovery page subtitle",
  },
  searchPlaceholder: {
    defaultMessage: "Search checkouts...",
    id: "yV1ONS",
    description: "payment recovery search placeholder",
  },
  emptyTitle: {
    id: "kW9yEQ",
    defaultMessage: "No stranded payments",
    description: "payment recovery empty state title",
  },
  emptyDescription: {
    id: "yBe+s9",
    defaultMessage: "Every checkout that took money has become an order. Nothing to resolve.",
    description: "payment recovery empty state description",
  },
  colDate: {
    id: "nvRcTK",
    defaultMessage: "Created",
    description: "payment recovery column",
  },
  colActivity: {
    id: "fOO2Ht",
    defaultMessage: "Last activity",
    description: "payment recovery column",
  },
  colCustomer: {
    id: "BarpCT",
    defaultMessage: "Customer",
    description: "payment recovery column",
  },
  colChannel: {
    id: "HKsoKu",
    defaultMessage: "Channel",
    description: "payment recovery column",
  },
  colItems: {
    id: "UapV97",
    defaultMessage: "Items",
    description: "payment recovery column",
  },
  colHeld: {
    id: "3fbM2a",
    defaultMessage: "Money held",
    description: "payment recovery column",
  },
  colGateway: {
    id: "y/DPlI",
    defaultMessage: "Gateway",
    description: "payment recovery column",
  },
  colLastEvent: {
    id: "46qp2O",
    defaultMessage: "Last event",
    description: "payment recovery column",
  },
  createOrder: {
    id: "0WNnlC",
    defaultMessage: "Create order",
    description: "payment recovery action",
  },
  refund: {
    id: "fowf3p",
    defaultMessage: "Refund",
    description: "payment recovery action",
  },
  voidAction: {
    id: "9Dc869",
    defaultMessage: "Void authorization",
    description: "payment recovery action",
  },
  createOrderDialogTitle: {
    id: "wQ6/eG",
    defaultMessage: "Create order from checkout",
    description: "payment recovery dialog title",
  },
  createOrderDialogContent: {
    id: "79Ea3T",
    defaultMessage:
      "This converts checkout {token} into an order for {amount}. The existing payment is carried over — the customer is not charged again.",
    description: "payment recovery dialog body",
  },
  refundDialogTitle: {
    id: "nntJyt",
    defaultMessage: "Return the money",
    description: "payment recovery dialog title",
  },
  refundDialogContent: {
    id: "SJegFJ",
    defaultMessage:
      "This returns {amount} to the customer for checkout {token}. No order is created and the checkout stays as it is.",
    description: "payment recovery dialog body",
  },
  partialAuthorizeHint: {
    id: "z4z76/",
    defaultMessage:
      "Only part of the total is covered, so an order created now would be underpaid. Return the money instead.",
    description: "payment recovery guidance",
  },
  releaseCountdown: {
    id: "COouXE",
    defaultMessage: "Auto-refunds {when}",
    description: "payment recovery release funds countdown",
  },
  releaseCountdownPassed: {
    id: "psROtE",
    defaultMessage: "Auto-refund is due",
    description: "payment recovery release funds countdown",
  },
  releaseDisabled: {
    id: "bSwxu0",
    defaultMessage: "No auto-refund on this channel",
    description: "payment recovery release funds countdown",
  },
  autoRefundLabel: {
    id: '/x5qr+',
    defaultMessage: "Auto-refund",
    description: "payment recovery auto-refund summary row label",
  },
  paymentsSection: {
    id: "mMPj3V",
    defaultMessage: "Payment attempts",
    description: "payment recovery section header",
  },
  contentsSection: {
    id: "R8sTuK",
    defaultMessage: "Contents",
    description: "payment recovery section header",
  },
  fraudSection: {
    id: "OO8dcz",
    defaultMessage: "Fraud screening",
    description: "payment recovery section header",
  },
  reconciliationSection: {
    id: "/vUwO0",
    defaultMessage: "Reconciliation",
    description: "payment recovery section header",
  },
  reconciliationStatus: {
    id: "aZ4QWP",
    defaultMessage: "Status",
    description: "payment recovery reconciliation field",
  },
  reconciliationReason: {
    id: "lwkcuK",
    defaultMessage: "Reason",
    description: "payment recovery reconciliation field",
  },
  contentDiffTitle: {
    id: "/Bs6u7",
    defaultMessage: "What changed before capture",
    description: "payment recovery reconciliation section",
  },
  orderSummarySection: {
    id: "7J3ELR",
    defaultMessage: "Order summary",
    description: "payment recovery section header",
  },
  paymentSummarySection: {
    id: "DMbG+7",
    defaultMessage: "Payment summary",
    description: "payment recovery section header",
  },
  subtotal: {
    id: "s+3jO1",
    defaultMessage: "Subtotal",
    description: "payment recovery order summary line",
  },
  shipping: {
    id: "SpaCgR",
    defaultMessage: "Shipping",
    description: "payment recovery order summary line",
  },
  taxes: {
    id: "PN0waf",
    defaultMessage: "Taxes",
    description: "payment recovery order summary line",
  },
  total: {
    id: "f/FOPf",
    defaultMessage: "Total",
    description: "payment recovery order summary line",
  },
  authorized: {
    id: "5HvZfu",
    defaultMessage: "Authorized",
    description: "payment recovery payment summary line",
  },
  captured: {
    id: "PI7yvA",
    defaultMessage: "Captured",
    description: "payment recovery payment summary line",
  },
  colProduct: {
    id: "fe82UN",
    defaultMessage: "Product",
    description: "payment recovery line items column",
  },
  colQuantity: {
    id: "OOncn6",
    defaultMessage: "Quantity",
    description: "payment recovery line items column",
  },
  colPrice: {
    id: "MwcPr/",
    defaultMessage: "Price",
    description: "payment recovery line items column",
  },
  colTotal: {
    id: "48uzz4",
    defaultMessage: "Total",
    description: "payment recovery line items column",
  },
  customerSection: {
    id: "+fCNqK",
    defaultMessage: "Customer",
    description: "payment recovery section header",
  },
  viewProfile: {
    id: "9X4W6j",
    defaultMessage: "View Profile",
    description: "payment recovery customer link",
  },
  anonymousUser: {
    id: "hRhcBe",
    defaultMessage: "Anonymous user",
    description: "payment recovery customer",
  },
  contactInformationSection: {
    id: "5VICHT",
    defaultMessage: "Contact Information",
    description: "payment recovery section header",
  },
  notSet: {
    id: "MsyGi5",
    defaultMessage: "Not set",
    description: "payment recovery empty field",
  },
  shippingAddressSection: {
    id: "uH90db",
    defaultMessage: "Shipping Address",
    description: "payment recovery section header",
  },
  billingAddressSection: {
    id: "NrqKS4",
    defaultMessage: "Billing Address",
    description: "payment recovery section header",
  },
  sameAsShipping: {
    id: "aTViTV",
    defaultMessage: "Same as shipping address",
    description: "payment recovery billing address",
  },
  noLines: {
    defaultMessage: "This checkout has no items left on it",
    id: "eKs27r",
    description: "payment recovery empty section",
  },
  noTransactions: {
    id: "UgkMsV",
    defaultMessage: "No transactions on this checkout",
    description: "payment recovery empty section",
  },
  orderCreated: {
    id: "T5wZjz",
    defaultMessage: "Order {number} created",
    description: "payment recovery success notification",
  },
  actionRequested: {
    id: "Ha2wPT",
    defaultMessage: "Requested from the payment app — the outcome appears in the timeline",
    description: "payment recovery success notification",
  },
  loadError: {
    id: "oNMwfL",
    defaultMessage: "Couldn't load this checkout. It may have already become an order.",
    description: "payment recovery error state",
  },
  authorizedOnly: {
    id: "s/IiDr",
    defaultMessage: "Authorized, not captured",
    description: "payment recovery money qualifier",
  },
  refundPendingPill: {
    id: "2FYbvl",
    defaultMessage: "Refund pending",
    description: "payment recovery transaction badge",
  },
  refundFailedPill: {
    id: "KLgY7h",
    defaultMessage: "Refund failed",
    description: "payment recovery transaction badge",
  },
  refundWarningTitle: {
    id: "+sio7g",
    defaultMessage: "Heads up before you refund again",
    description: "payment recovery dialog warning heading",
  },
  refundWarningPending: {
    id: "RXJlcT",
    defaultMessage:
      "{gateway} ({amount}): a refund was already requested on {date} and hasn't resolved yet. Sending another risks a second, concurrent refund.",
    description: "payment recovery dialog warning body",
  },
  refundWarningFailed: {
    id: "sKXoIE",
    defaultMessage:
      "{gateway} ({amount}): the last refund attempt on {date} failed — \"{message}\". Confirm with the gateway before retrying.",
    description: "payment recovery dialog warning body",
  },
});
